module.exports = __webpack_public_path__ + "static/media/no-connection.ac705d3d.svg";